import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { MailX, CheckCircle2, Loader2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Baja de los mails de novedades y venta (link al pie de cada mail).
 * La baja se hace con el botón, no al abrir el link: algunos antivirus de
 * correo abren los links solos y darían de baja a la persona sin querer.
 */
export default function BajaMailsPage() {
  const [params] = useSearchParams();
  const token = params.get('t') || '';
  const [estado, setEstado] = useState('pregunta'); // pregunta | enviando | listo | prueba | error

  const confirmar = async () => {
    setEstado('enviando');
    try {
      const res = await fetch(`${API}/api/mails/baja`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ t: token }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.detail || 'error');
      setEstado(data.prueba ? 'prueba' : 'listo');
    } catch {
      setEstado('error');
    }
  };

  let contenido;
  if (!token || estado === 'error') {
    contenido = (
      <>
        <h1 className="text-2xl sm:text-3xl font-bold text-white tracking-tight">No pudimos darte de baja</h1>
        <p className="mt-4 text-slate-300 leading-relaxed">
          El link no es válido o está incompleto. Respondé cualquiera de los mails con la palabra
          "baja" y te saco de la lista a mano.
        </p>
      </>
    );
  } else if (estado === 'listo' || estado === 'prueba') {
    contenido = (
      <>
        <CheckCircle2 className="h-10 w-10 text-[#7BC24A] mx-auto mb-4" />
        <h1 className="text-2xl sm:text-3xl font-bold text-white tracking-tight" data-testid="baja-lista">
          Listo, no te escribo más
        </h1>
        <p className="mt-4 text-slate-300 leading-relaxed">
          {estado === 'prueba'
            ? 'Este era un mail de prueba: no se dio de baja a nadie.'
            : 'No vas a recibir más mails de novedades. Si tenés cuenta en EVALPRO, los avisos de tu cuenta (accesos, compras) te siguen llegando.'}
        </p>
      </>
    );
  } else {
    contenido = (
      <>
        <MailX className="h-10 w-10 text-slate-300 mx-auto mb-4" />
        <h1 className="text-2xl sm:text-3xl font-bold text-white tracking-tight">
          ¿Querés dejar de recibir mis mails?
        </h1>
        <p className="mt-4 text-slate-300 leading-relaxed">
          Son los mails de Fede, de Ejercicio Físico y Salud, sobre EVALPRO.
        </p>
        <Button
          size="lg"
          onClick={confirmar}
          disabled={estado === 'enviando'}
          data-testid="baja-confirmar"
          className="mt-7 h-12 px-8 bg-[#5B9B2F] hover:bg-[#4a8126] text-white font-bold rounded-xl"
        >
          {estado === 'enviando' && <Loader2 className="h-5 w-5 mr-2 animate-spin" />}
          Confirmar baja
        </Button>
      </>
    );
  }

  return (
    <div className="min-h-screen bg-[#0D1B2A] flex flex-col items-center justify-center px-4 py-12">
      <div className="w-full max-w-lg bg-white/5 border border-white/10 rounded-2xl p-8 sm:p-10 text-center">
        {contenido}
      </div>
    </div>
  );
}
